<div class="row post comments comment-border" [ngClass]="taskId? 'taskComments': ''">
  <div class="medium-12">

    <!-- Display comment -->
    <ng-template [ngIf]="updateObj.id !== comment.id">
      <div class="row post-user">
        <div *ngIf="comment.user && !comment.user.bot && comment.user.thumbnail && comment.user.thumbnail.length > 0" style="margin-right: 10px" (click)="displayInfo()">
          <div class="posts-thumbnail" [ngStyle]="{'background': 'url(' + comment.user.thumbnail + ') center center no-repeat'}"></div>
        </div>
        <div class="round user-badge-name" *ngIf="comment.user && !comment.user.bot" [hidden]="comment.user.thumbnail" [style.background-color]="comment.user.colorCode" (click)="displayInfo()">
          {{comment.user.firstName.charAt(0)}}{{comment.user.lastName.charAt(0)}}
        </div>
        <div class="widget-container" *ngIf="displayUserInfoWidget" (clickOutside)="closeDisplayInfo()">
          <app-display-info  [info]="comment" [pageType]="'comment'"></app-display-info>
        </div>
        <div class="round bot-image-name" *ngIf="comment.user.bot">
          <img src="https://static.taxplaniq.com/futurefirm/favicon_new.png">
        </div>
        <div class="medium-10">
          <span class="user float-left">{{comment.user.firstName}}</span>
          <span class="user float-left" *ngIf="!comment.user.bot">{{comment.user.lastName}}</span>
          <span class="mentioned-users" style="font-size: 14px" *ngIf="comment.mentionIds && comment.mentionIds.length > 0">{{comment.mention_message}}</span>
          <pre class="post-pre comment-pre float-left" style="margin-bottom: 10px" *ngIf="!comment.html_message" [innerHTML]="comment.message | linky:{stripPrefix: false}"></pre>
          <div class="post-pre comment-pre" style="margin-bottom: 10px;width:initial;" *ngIf="comment.html_message" [froalaView]="comment.html_message | linky:{stripPrefix: false}"></div>
        </div>
        <div class="column text-right update-dropdown options-list">
          <ul class="vertical medium-horizontal menu">
            <li class="is-dropdown-submenu-parent opens-left">
              <i class="material-icons pointer more-horiz post_options" aria-hidden="true">more_horiz</i>
              <ul class="vertical post-option-wrapper is-dropdown-submenu" (clickOutside)="hidePostOptions()">
                <li class="is-dropdown-submenu-item other-option" *ngIf="user.id === comment.user.id"><a href="javascript:void (0)" (click)="handleCommentAction('edit')">Edit message</a></li>
                <li class="is-dropdown-submenu-item other-option" *ngIf="user.id === comment.user.id"><a href="javascript:void (0)" (click)="handleCommentAction('delete')">Delete</a></li>
              </ul>
            </li>
          </ul>
        </div>
      </div>

      <div class="row post-comment" *ngIf="comment.documents.length>0 && !isDocView">
        <div class="column attachment post-uploaded-doc" [ngClass]="taskId ? 'medium-5' : 'medium-5'" *ngFor="let attachment of comment.documents">
          <div class="row comment-row">
            <div class="medium-9  pointer file-font" attr.title="{{attachment.name}}" *ngIf="!attachment.imageType">
              <div class="attachment_name" (click)="downloadDocument(attachment, 'preview')">{{attachment.name}}</div>
            </div>
            <div class="medium-9 commonColor2  pointer" attr.title="{{attachment.name}}" *ngIf="attachment.imageType">
              <img class="image-zoom" [src]="attachment.temporaryURL" (click)="openImage(attachment)"/>
            </div>
            <div class="column medium-3 post-icons">
              <i class="icon ion-ios-cloud-download-outline commonColor2 float-right post-icons-pad" (click)="downloadDocument(attachment, 'download')"></i>
              <i class="icon ion-ios-trash commonColor2 remove-upload float-right" (click)="removeAttachment(attachment.id,comment)"></i>
            </div>
          </div>
        </div>
        <div class="column medium-7"></div>
      </div>

      <div class="row post-body document-preview" *ngIf="comment.documents.length > 0 && isDocView">
        <div class="row full-width" *ngFor="let taxdoc of comment.documents">
          <div class="column medium-11">
            <div *ngIf="taxdoc.imageType">
              <img class="image-zoom" [src]="taxdoc.temporaryURL" />
            </div>
            <div *ngIf="taxdoc.ispdf">
              <iframe class="image-zoom" [src]="taxdoc.pdfLink | safeurl: 'https://docs.google.com/gview?embedded=true&url='" frameborder="0"></iframe>
            </div>
          </div>
        </div>
      </div>

      <div class="row post-body">
        <div class="column medium-11">
          <span class="likeOptions pointer" [ngClass] = "showReplySection ? 'commonColor2' : 'commonColor1'" (click)="onReplyClick(comment.id)">{{showReplySection ? 'Hide' : 'Reply'}}</span>
          <span class="likeSeparator likeOptions commonColor2">.</span>
          <span class="likeOptions commonColor2 post-dateTime-dropdown">
            <span class="display-date">{{comment.displayDate}}</span>
            <span class="tooltip-date">{{comment.tooltipDate}}</span>
          </span>
          <span class="likeOptions commonColor2 badge-wrapper" *ngFor="let badge of comment.badges; let i = index;">
            <a href="javascript:void (0)" class="button comment-status" [style.background-color]="getColor(badge)">{{badge}}</a>
          </span>
        </div>
      </div>
    </ng-template>

    <section class="upload-area">
      <div class="row comment-upload-area" *ngIf="showReplySection">
        <div class="column medium-12 current-mentions" *ngIf="mentions && mentions.length > 0">
          You are mentioning:
          <span class="mentioned-users">{{mentions}}</span>
        </div>
        <div class="postAttachment medium-4 columns" *ngIf="postUploadResp.length > 0">
          <div class="row" *ngFor="let attachment of postUploadResp">
            <div class="medium-7 commonColor2  pointer" attr.title="{{attachment.name}}" *ngIf="!attachment.imageType">
              <div class="attachment_name" (click)="downloadDocument(attachment, 'preview')">{{attachment.name}}</div>
            </div>
            <div class="medium-7 commonColor2  pointer" attr.title="{{attachment.name}}" *ngIf="attachment.imageType">
              <img class="image-zoom" [src]="attachment.temporaryURL" (click)="openImage(attachment)"/>
            </div>
            <div class="column medium-1">
              <i class="icon ion-ios-trash commonColor2" (click)="deleteAttachment(attachment.id)"></i>
            </div>
          </div>
        </div>
        <div class="postAttachment medium-4 columns" *ngIf="documentsData.length>0">
          <div class="row" *ngFor="let document of documentsData">
            <div class="column medium-7 commonColor2 pointer" attr.title="{{document['file'].name}}">
              <div class="attachment_name">{{document['file'].name}}</div>
            </div>
            <div class="column medium-1" (click)="removeDocument(document)">
              <i class="icon ion-ios-trash commonColor2"></i>
            </div>
          </div>
        </div>
        <div class="column medium-12">
          <div class="row">
            <div class="column medium-12">
              <div *ngIf="user.thumbnail && user.thumbnail.length > 0" style="float: left;margin-right: 10px;line-height: 37px;">
                <div class="posts-thumbnail" [ngStyle]="{'background': 'url(' + user.thumbnail + ') center center no-repeat'}"></div>
              </div>
              <div class="round commented-by" [hidden]="user.thumbnail" [style.background-color]="user.colorCode">
                {{user.first_name.charAt(0)}}{{user.last_name.charAt(0)}}
              </div>
              <div class="inputContainer">
                <div class="new-comment-wrapper">
                  <textarea class="direct-text-box new-comment-textarea" [(ngModel)]="subComment" autosize placeholder="{{placeHolder}}" *ngIf="messageHeight"
                            (keydown.enter)="onSubCommentEnter($event,comment)"></textarea>
                </div>
                <div class="inputAttachments">
                  <span class="pointer" (click)="showMentionWidget()">&#64;</span>
                  <div class="zero-right-margin" *ngIf="showMentionDropdown && isTpiqOrgUser" (clickOutside)="closeMentionContainer()">
                    <app-label-input-search [setData]="mentionUsers" [selectedData]="mentionIds" [displayKey]="'name'" (onLabelSearchSelection)="mentionSelected($event)"
                                            [removeLabelClass] = true (onLabelRemove)="removeMention($event)"></app-label-input-search>
                  </div>
                  <div class="zero-right-margin" *ngIf="showMentionDropdown && !isTpiqOrgUser" (clickOutside)="closeMentionContainer()">
                    <app-label-input-search [setData]="clientInternalUsers" [selectedData]="mentionIds" [displayKey]="'name'" (onLabelSearchSelection)="mentionSelected($event)"
                                            [removeLabelClass] = true (onLabelRemove)="removeMention($event)"></app-label-input-search>
                  </div>
                  <span class="float-left">
                    <label class="button upload_button">
                      <span (click)="triggerFileUpload(comment)"><i class="material-icons">attach_file</i></span>
                    </label>
                    <input type="file" id="comment-{{comment.id}}" (change)="startUpload($event, 'newSubcomment')" value="null" class="show-for-sr" ng2FileSelect [uploader]="uploader" multiple/>
                  </span>
                  <span class="float-left new-comment"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Edit comment-->
    <div class="row editing-comment" *ngIf="updateObj.id === comment.id" (keydown.escape)="stopEditing()">
      <div class="column medium-12">
        <div class="row">
          <div class="postAttachment" *ngIf="postUploadResp.length > 0">
            <div class="row" *ngFor="let attachment of postUploadResp">
              <div class="medium-7 commonColor2  pointer" attr.title="{{attachment.name}}" *ngIf="!attachment.imageType">
                <div class="attachment_name" (click)="downloadDocument(attachment, 'preview')">{{attachment.name}}</div>
              </div>
              <div class="medium-7 commonColor2  pointer" attr.title="{{attachment.name}}" *ngIf="attachment.imageType">
                <img class="image-zoom" [src]="attachment.temporaryURL" (click)="openImage(attachment)"/>
              </div>
              <div class="column medium-1">
                <i class="icon ion-ios-trash commonColor2" (click)="deleteAttachment(attachment.id)"></i>
              </div>
            </div>
          </div>
          <div class="postAttachment" *ngIf="documentsData.length>0">
            <div class="row" *ngFor="let document of documentsData">
              <div class="column medium-7 commonColor2 pointer" attr.title="{{document['file'].name}}">
                <div class="attachment_name">{{document['file'].name}}</div>
              </div>
              <div class="column medium-1" (click)="removeDocument(document)">
                <i class="icon ion-ios-trash commonColor2"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="column medium-12">
            <div *ngIf="updateObj.user.thumbnail && updateObj.user.thumbnail.length > 0" style="float: left;margin-right: 10px;line-height: 37px;">
              <div class="posts-thumbnail" [ngStyle]="{'background': 'url(' + updateObj.user.thumbnail + ') center center no-repeat'}"></div>
            </div>
            <div class="round commented-by" [hidden]="updateObj.user.thumbnail" [style.background-color]="updateObj.user.colorCode">
              {{updateObj.user.firstName.charAt(0)}}{{updateObj.user.lastName.charAt(0)}}
            </div>
            <div class="inputContainer">
              <div class="text-area-wrapper">
                <textarea class="direct-text-box new-comment-textarea comment-editor" *ngIf="!updateObj.html_message" autosize [froalaEditor]="editorOptions" [(froalaModel)]="updateObj.message" [isEditComment]="true"
                          placeholder="{{placeHolder}}" (keydown.enter)="onUpdateEnter($event, 'comment')"></textarea>
                <textarea class="direct-text-box new-comment-textarea comment-editor" *ngIf="updateObj.html_message" autosize [froalaEditor]="editorOptions" [(froalaModel)]="updateObj.html_message" [isEditComment]="true"
                          placeholder="{{placeHolder}}" (keydown.enter)="onUpdateEnter($event, 'comment')"></textarea>
              </div>
              <div class="inputAttachments">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row post-body pointer comment-body" [ngClass]="{'comment-body': hideReplies}">
      <div class="column medium-11">
        <div *ngIf="comment.children.length>0" (click)="showCommentToggle()">
          <ng-template [ngIf]="hideReplies">
            <i class="fa fa-chevron-up hide-icon"></i>
            <span>Hide </span>
          </ng-template>
          <ng-template [ngIf]="!hideReplies">
            <i class="fa fa-reply" style="transform: rotate(180deg);font-size: 10px;"></i>
            <span>View </span>
          </ng-template>
          <span>{{comment.children.length}} </span>
          <span *ngIf="comment.children.length > 1">replies</span>
          <span *ngIf="comment.children.length === 1">reply</span>
        </div>
      </div>
    </div>

    <app-sub-comment [data]="comment.children" [pageType]="pageType" [channelType] = "channelType" [comment]="comment" [taskId]="taskId" [companyId]="companyId" *ngIf="comment.children.length>0" [hidden]="!hideReplies"
                 [org]= "org" id="commentToggle{{comment.id}}" [clientInternalUsers]="clientInternalUsers" (onDeleteSubComment)="handleCommentDeleteAction($event)"></app-sub-comment>
  </div>
</div>
